package io.horion.cv.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.styles.BlueGradientTextStyle
import io.horion.cv.styles.ImagesPreviewSectionStyle
import io.horion.cv.styles.ProcedureArrowStyle
import io.horion.cv.utils.Colors
import io.horion.cv.styles.ProcedureImageStyle
import io.horion.cv.styles.ProcedureSectionStyle
import io.horion.cv.styles.ProcedureSpacerStyle
import io.horion.cv.styles.ProcedureTitleContainerStyle
import io.horion.cv.styles.ProcedureTitleStyle
import io.horion.cv.styles.StepBadgeStyle
import io.horion.cv.styles.StepCardStyle
import io.horion.cv.styles.StepNumberStyle
import io.horion.cv.styles.StepTextStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Img

@OptIn(DelicateApi::class)
@Composable
fun ProcedureSection() {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val sectionBg = if (isDark) Colors.DarkBG else Colors.White

    Column (
        modifier = ProcedureSectionStyle.toModifier()
            .fillMaxWidth()
            .backgroundColor(sectionBg)
            .styleModifier { property("transition", "background-color 300ms ease") },
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Row(
            modifier = ProcedureTitleContainerStyle.toModifier(),
            horizontalArrangement = Arrangement.Center,
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(
                "Une procedure simple",
                modifier = BlueGradientTextStyle.toModifier()
                    .then(ProcedureTitleStyle.toModifier())
            )
        }

        Box(modifier = ProcedureSpacerStyle.toModifier()
            )

        Row(
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.fillMaxWidth()
        ) {
            StepCard(
                number = "1",
                text = "Choisissez un modèle de CV\nqui est adapté à votre besoin.",
            )

            Arrow(
                img = "arrow1.svg",
            )

            StepCard(
                number = "2",
                text = "Remplissez le formulaire\navec les infos qui constituent\nle contenu de votre CV.",
            )

            Arrow(
                img = "arrow2.svg",
            )

            StepCard(
                number = "3",
                text = "Téléchargez votre CV\net modifiez-le à tout moment.",
            )
        }
    }
    ImagesPreviewSection()
}

@Composable
fun StepCard(
    number: String,
    text: String,
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val textColor = if (isDark) Colors.White else Colors.DarkBlue
    val numberBg  = if (isDark) Colors.DarkBG else Colors.White

    Box(
        modifier = StepCardStyle.toModifier()
            .position(Position.Relative),
        contentAlignment = Alignment.TopCenter
    ) {
        Box(
            modifier = StepBadgeStyle.toModifier()
                .position(Position.Absolute)
                .border(width = 1.px, style = LineStyle.Solid, color = Colors.bluelight)
                .backgroundColor(numberBg),
            contentAlignment = Alignment.TopCenter
        ) {
            SpanText(
                number,
                modifier = StepNumberStyle.toModifier()
            )
        }

        Column(
            modifier = Modifier.fillMaxWidth().fillMaxHeight(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ){
            SpanText(
                text,
                modifier = StepTextStyle.toModifier()
                    .color(textColor)
            )
        }
    }
}

@Composable
fun Arrow(
    img: String,
) {
    Img(
        src = img,
        attrs = ProcedureArrowStyle.toModifier()
            .toAttrs()
    )
}

@OptIn(DelicateApi::class)
@Composable
fun ImagesPreviewSection() {
    Row(
        modifier = ImagesPreviewSectionStyle.toModifier(),
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Image(
            modifier = ProcedureImageStyle.toModifier(),
            src = "image1.webp",
            description = "CV 1",
        )
        Image(
            modifier = ProcedureImageStyle.toModifier(),
            src = "image2.webp",
            description = "CV 2",
        )
        Image(
            modifier = ProcedureImageStyle.toModifier(),
            src = "image3.webp",
            description = "CV 3",
        )
    }
}
